'use strict';

function CompanyPublicationFileService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/files/:fileId', {}, {
    'update': {
      method: 'PUT'
    },
    'getFileToken': {
      method: 'POST',
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/files/:fileId/tokens'
    },
    'getPreview': {
      method: 'GET',
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/files/:fileId/preview'
    },
    'getLastFile': {
      method: 'GET',
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/files/last-file'
    },
    'getShowFile': {
      method: 'GET',
      url: config.apiBase + '/companies/:companyId/show-files/:fileId'
    },
    'rotateImage':  {
      method: 'PATCH',
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/files/:fileId/rotate'
    },
    'fileContent': {
      method: 'GET',
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/files/:fileId/content'
    },
    'updateSearchable': {
      method: 'PUT',
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/files/:fileId/search-able'
    },
    'updateFileContent': {
      method: 'PUT',
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/files/:fileId/content'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyPublicationFileService', ['$resource', 'config', CompanyPublicationFileService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationFileService.js
// module id = 9
// module chunks = 0